<template>
	<div>
		<el-form ref="ruleForm" label-width="120px" class="demo-ruleForm">
			<div style="display: flex; flex-direction: row;">
				<el-form-item label="渠道名">
					<el-input size="small" v-model="Info.payInfo.pay_name" disabled></el-input>
				</el-form-item>
				<el-form-item label="渠道编码">
					<el-input size="small" v-model="Info.payInfo.pay_code" disabled></el-input>
				</el-form-item>
			</div>
			<div style="display: flex; flex-direction: row;">
				<el-form-item label="姓名">
					<el-input size="small" v-model="Info.applyParams.realname" ></el-input>
				</el-form-item>
				<el-form-item label="身份证">
					<el-input size="small" v-model="Info.applyParams.idcard" ></el-input>
				</el-form-item>
			</div>
			<div style="display: flex; flex-direction: row;">
				<el-form-item label="手机号">
					<el-input size="small" v-model="Info.applyParams.phone" ></el-input>
				</el-form-item>
				<el-form-item label="开户行">
					<el-input size="small" v-model="Info.applyParams.bank_addr" ></el-input>
				</el-form-item>
			</div>
			<div style="display: flex; flex-direction: row;">
				<el-form-item label="身份证">
					<el-image :src="Info.applyParams.idcard1" :preview-src-list="[Info.applyParams.idcard1]" lazy style="width: 100px; height: 100px;"></el-image>
					<el-image :src="Info.applyParams.idcard2" :preview-src-list="[Info.applyParams.idcard2]" lazy style="width: 100px; height: 100px; margin-left: 20px;"></el-image>
				</el-form-item>
				
				<el-form-item label="银行卡">
					<el-image :src="Info.applyParams.bank1" :preview-src-list="[Info.applyParams.bank1]" lazy style="width: 100px; height: 100px;"></el-image>
					<el-image :src="Info.applyParams.bank2" :preview-src-list="[Info.applyParams.bank2]" lazy style="width: 100px; height: 100px; margin-left: 20px;"></el-image>
				</el-form-item>
			</div>
			
			<el-form-item label="操作" prop="status">
				<el-select v-model="Info.status">
				      <el-option label="待处理" :value="0"></el-option>
				      <el-option label="已同意" :value="1"></el-option>
					  <el-option label="已拒绝" :value="2"></el-option>
					  <el-option label="重新进件" :value="3"></el-option>
				</el-select>
			</el-form-item>
			
			<el-form-item label="商户号" prop="remarks">
				<el-input size="small" v-model="Info.actionParams.merchant_no" placeholder="通过申请时,填写商户号"></el-input>
			</el-form-item>
			
			<el-form-item label="商户密钥" prop="remarks">
				<el-input size="small" v-model="Info.actionParams.app_key" placeholder="通过申请时,填写商户密钥"></el-input>
			</el-form-item>
			
			<el-form-item label="审核备注" prop="remarks">
				<el-input size="small" v-model="Info.remark"></el-input>
			</el-form-item>
			
			<el-form-item>
				<el-button type="primary" @click="submitApi()">确认操作</el-button>
			</el-form-item>
		</el-form>
	</div>
</template>

<script>
	export default {
		props:['Info'],
	    data() {
			return {
				realname:'',
	      };
	    },
	    methods: {
			submitApi(){
				let _this = this;
				if(this.Info.status == 1){
					if(this.Info.applyParams.realname == ''){
						return _this.$message({
							 message: '请填写姓名~',
							 type: 'warning',
						});
					}
					if(this.Info.actionParams.merchant_no == ''){
						return _this.$message({
							 message: '请填写商户号~',
							 type: 'warning',
						});
					}
					if(this.Info.actionParams.app_key == ''){
						return _this.$message({
							 message: '请填写商户密钥~',
							 type: 'warning',
						});
					}
				}
				if(this.Info.status == 0){
					return _this.$message({
						 message: '请选择操作状态~',
						 type: 'warning',
					});
					return;
				}
				
				let _param = {
					id:_this.Info.id,
					status:_this.Info.status,
					remark:_this.Info.remark,
					pay_id:_this.Info.pay_id,
					alipay:_this.Info.applyParams.alipay,
					realname:_this.Info.applyParams.realname,
					phone:_this.Info.applyParams.phone,
					merchant_no:_this.Info.actionParams.merchant_no,
					app_key:_this.Info.actionParams.app_key
				}
				
				const loading = this.$loading({
						lock: true,
						text: '处理中',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.7)'
					});
				_this.$api.post("/Recharge/actionLsPayApply", _param).then(res=>{
					loading.close();
					if(res.code == 200)
					{
						_this.$message({
							 message: '操作成功~',
							 type: 'success',
						});
					}else{
						return _this.$message({
							 message: res.msg,
							 type: 'warning',
						});
					}
				}).catch(err=>{
					loading.close();
				});
			},
			submitForm(formName) {
				let _this = this;
				this.$refs[formName].validate((valid) => {
					if (valid) {
						_this.submitApi();
					} else {
						return _this.$message({
							 message: '提交失败',
							 type: 'warning',
						});
					}
				});
			},
			resetForm(formName) {
				this.$refs[formName].resetFields();
			}
	    }
	  }
</script>

<style scoped>
	.avatar-uploader .el-upload {
	    border: 1px dashed #d9d9d9;
	    border-radius: 6px;
	    cursor: pointer;
	    position: relative;
	    overflow: hidden;
	  }
	  .avatar-uploader .el-upload:hover {
	    border-color: #409EFF;
	  }
	  .avatar-uploader-icon {
	    font-size: 28px;
	    color: #8c939d;
	    min-width: 80px;
	    height: 80px;
	    line-height: 80px;
	    text-align: center;
		border: solid 1px #dcdcdc;
	  }
	  .avatar {
	    min-width: 80px;
	    height: 80px;
	    display: block;
	  }
</style>